// @flow

import React from "react";
import styled from "styled-components";

import { Flex, Text } from "@src/common";
import spacingExtender from "@src/common/spacingExtender";
import { riskColorMapping } from "@src/common/colors";

const Header = styled.div`
  box-shadow: ${({ theme }) => theme.shadow};
  background-color: #fff;
  border-radius: 5px;
  height: 40px;
  left: 15px;
  position: absolute;
  right: 15px;
  z-index: 2;
  overflow: hidden;
`;

const HeaderInfo = styled(Flex)`
  cursor: pointer;
  color: #fff;
  height: 40px;
`;

const HeaderTitle = styled(Flex)`
  cursor: pointer;
  height: 40px;
`;

const RiskBox = styled(Flex)`
  text-align: center;
  border-right-width: 1px;
  border-right-style: solid;
  ${spacingExtender({ paddingH: "4" })};
  &:last-child {
    border-right-style: none;
  };
`;

const RiskBoxBar = styled(Flex)`
  min-height: 15px;
  ${spacingExtender({ marginV: "2" })};
`;

const HeaderBody = () => (
  <Flex flexDirection="column" alignItems="flex-start" margin={3}>
    <Text type="bold" size={4} style={{ width: "100%", flexBasis: "15px" }}>
      Risk Rating Reference
    </Text>
    <Text
      type="book"
      size={4}
      marginV="1"
      style={{ width: "100%", flexBasis: "100px" }}
    >
      Apply the total behaviour score to the Risk Rating Scale to determine whether the client’s risk level is low, moderate, high or very high. Each level provides cues for further action to consider.  If moderate or high / very high risk is determined, complete Section C to identify factors that may trigger or escalate violent, aggressive, or responsive behaviour and ensure the care plan includes measures to avoid or reduce risk behaviours identified.
    </Text>
    <Flex marginV={3} style={{ flexBasis: "100px" }}>
      <RiskBox flexDirection="column" style={{ flexBasis: "40px" }}>
        <Text type="medium" size={1}>0</Text>
        <Text type="book" size={4}>Low</Text>
        <RiskBoxBar backgroundColor={riskColorMapping[0]} />
      </RiskBox>
      <RiskBox flexDirection="column" style={{ flexBasis: "40px" }}>
        <Text type="medium" size={1}>1-3</Text>
        <Text type="book" size={4}>Moderate</Text>
        <RiskBoxBar backgroundColor={riskColorMapping[1]} />
      </RiskBox>
      <RiskBox flexDirection="column" style={{ flexBasis: "40px" }}>
        <Text type="medium" size={1}>4-5</Text>
        <Text type="book" size={4}>High</Text>
        <RiskBoxBar backgroundColor={riskColorMapping[2]} />
      </RiskBox>
      <RiskBox flexDirection="column" style={{ flexBasis: "40px" }}>
        <Text type="medium" size={1}>6+</Text>
        <Text type="book" size={4}>Very High</Text>
        <RiskBoxBar backgroundColor={riskColorMapping[3]} />
      </RiskBox>
    </Flex>
  </Flex>
);

export { Header, HeaderBody, HeaderTitle, HeaderInfo };



// WEBPACK FOOTER //
// ./src/containers/Assessment/components/RiskHeader/components/index.jsx